import type { IntentProps } from '../../../core/slots/Intent/Intent.js';

export const isToolbarEnabled = <
  T extends {
    hidden?: boolean;
    downloadCSV?: { enabled?: boolean };
    downloadData?: { enabled?: boolean };
    intents?: Array<IntentProps>;
  },
>(
  config: T | undefined,
) => {
  return !!(
    config?.hidden !== true &&
    (config?.downloadCSV?.enabled ||
      config?.downloadData?.enabled ||
      config?.intents?.length)
  );
};
